import { render, staticRenderFns } from "./BuyPeachSuccessful.vue?vue&type=template&id=3c9bc953&scoped=true"
import script from "./BuyPeachSuccessful.vue?vue&type=script&lang=js"
export * from "./BuyPeachSuccessful.vue?vue&type=script&lang=js"
import style0 from "./BuyPeachSuccessful.vue?vue&type=style&index=0&id=3c9bc953&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9bc953",
  null
  
)

export default component.exports